import { render, staticRenderFns } from "./SpecialtyDelete.vue?vue&type=template&id=257cb96b&"
import script from "./SpecialtyDelete.vue?vue&type=script&lang=js&"
export * from "./SpecialtyDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports